<div class="container mx-auto px-0 py-0">
  <div class="bg-white shadow-md rounded-lg p-6">
    <!-- Simple Header -->
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900">Support & Hilfe</h1>
      <p class="text-gray-600">
        Brauchen Sie Hilfe oder haben Sie Fragen? Unser Support-Team steht Ihnen gerne zur Verfügung.
      </p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Contact Form -->
      <div class="bg-gray-50 rounded-lg p-6">
        <h2 class="text-xl font-semibold text-gray-900 mb-2">Support-Anfrage senden</h2>
        <p class="text-gray-600 mb-4">Beschreiben Sie Ihr Problem und wir helfen Ihnen gerne weiter</p>
        
        <div>
          <form (ngSubmit)="sendSupport()" [formGroup]="supportForm" novalidate>
            <!-- Subject Field -->
            <div class="form-group">
              <label class="form-label" for="subject">Betreff *</label>
              <input
                type="text"
                class="form-control"
                id="subject"
                formControlName="subject"
                placeholder="Kurze Beschreibung Ihres Problems"
                class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                [class.is-invalid]="supportForm.controls['subject'].invalid && supportForm.controls['subject'].touched" />
              <div *ngIf="supportForm.controls['subject'].invalid && supportForm.controls['subject'].touched" class="text-red-500 text-sm mt-1">
                Betreff muss angegeben werden
              </div>
            </div>

            <!-- Message Field -->
            <div class="form-group">
              <label class="form-label" for="message">Nachricht *</label>
              <textarea
                class="form-control"
                id="message"
                formControlName="message"
                placeholder="Beschreiben Sie Ihr Problem oder Ihre Frage ausführlich..."
                rows="6"
                class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                [class.is-invalid]="supportForm.controls['message'].invalid && supportForm.controls['message'].touched"></textarea>
              <div *ngIf="supportForm.controls['message'].invalid && supportForm.controls['message'].touched" class="text-red-500 text-sm mt-1">
                Nachricht muss angegeben werden
              </div>
            </div>

            <!-- Submit Button -->
            <div class="form-group">
              <button
                type="submit"
                [disabled]="supportForm.invalid"
                class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg w-full flex items-center justify-center">
                <mat-icon class="mr-2">send</mat-icon>
                Anfrage senden
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Contact Information -->
      <div class="space-y-6">
        <!-- Direct Contact -->
        <div class="bg-gray-50 rounded-lg p-6">
          <h2 class="text-xl font-semibold text-gray-900 mb-2">Direkter Kontakt</h2>
          <p class="text-gray-600 mb-4">Kontaktieren Sie uns direkt</p>
          
          <div>
            <div class="space-y-6">
              <!-- Email -->
              <div class="flex items-start space-x-4">
                <div class="flex-shrink-0">
                  <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">E-Mail</h3>
                  <p class="text-gray-600">support&#64;labor-c.net</p>
                  <a href="mailto:support&#64;labor-c.net" class="text-blue-600 hover:text-blue-800 text-sm">E-Mail senden</a>
                </div>
              </div>

              <!-- Phone -->
              <div class="flex items-start space-x-4">
                <div class="flex-shrink-0">
                  <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                    <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">Telefon - von 9:00 bis 12:00 Uhr</h3>
                  <p class="text-gray-600">+43 1 890 39 54</p>
                  <a href="tel:+4318903954" class="text-blue-600 hover:text-blue-800 text-sm">Anrufen</a>
                </div>
              </div>

              <!-- Address -->
              <div class="flex items-start space-x-4">
                <div class="flex-shrink-0">
                  <div class="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">Adresse</h3>
                  <p class="text-gray-600">
                    Pappenheimgasse 33/10<br>
                    1200 Wien<br>
                    Österreich
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>




      </div>
    </div>
  </div>
</div>
